import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { ProductImage } from '@cps'
import { format } from '@dt/fe-utils'
import { storeDisplayMobx } from '@mobx/app'
import './index.scss'

interface IProps {
  data: IViewStore;
  style: any;
  onClick: () => void;
}

const StoreItem: FC<IProps> = ({ data, style, onClick }: IProps) => {
  const [defaultImg, setDefault] = useState<string>('')
  /** 获得图片的宽高 */
  const [storeStyle, setStoreStyle] = useState({ width: 178, height: 100 })
  const storeSaleTime = format.toSaleTime(data.saleTime, bo === 'cn' ? '24' : '12')
  const getPicUrl = (store) => {
    const pics = format.toPic(store?.storeExtInfo?.storePic)
    setDefault(pics.url)
    calcStoreStyle(pics)
  }

  const calcStoreStyle = (pics) => {
    const imgWidth = window.innerWidth / 2 - storeDisplayMobx.getWidthPer(3)
    const imgHeight = imgWidth / Number(pics.w || 178) * Number(pics.h || 100)
    setStoreStyle({ width: imgWidth, height: imgHeight })
  }

  useEffect(() => {
    getPicUrl(data)
  }, [data])

  return (
    <div
      className='store-display-item-wrappper'
      style={style ? {
        left: style.left,
        top: style.top
      } : null}
      id={`store-display-${data.storeId}`}
      onClick={() => onClick()}
    >
      {
        !defaultImg
          ? (
            <div className='empty-img'></div>
          ) : (
            <ProductImage
              imgSrc={defaultImg}
              width={storeStyle.width}
              height={storeStyle.height}
              className='waterfall-img'
            />
          )
      }
      <div className='store-info'>
        <div className='store-name-wrap'>
          <div className='store-name'>{data.storeName}</div>
          <div className='distance'>{data.distanceWithUnit}</div>
        </div>
        <div className='item-wrap'>
          {storeSaleTime.map((v, index: number) => <p key={index}>{v}</p>)}
        </div>
      </div>
    </div>
  )
}

export default observer(StoreItem)
